<template>
  <div class="child">
    <div class="tip">
      为了给您宝贝推荐更适合她的锻炼方法，或者相关教育内容，请您如实选择孩子信息，如有相关权威诊断可上传，辅助专家为您提供更适合的治疗方案。
    </div>
    <div v-if="studentList.length > 1" class="content-name">
      <div
        v-for="(item, index) in studentList"
        :key="index"
        :class="{ active: index === activeIndex }"
        @click="changeStudent(item, index)"
      >
        <span>孩{{ index + 1 }}:</span
        ><span>{{ item.studentName || "--" }}</span>
      </div>
    </div>
    <van-form
      v-for="(item, index) in studentList"
      :key="index"
      :style="{ display: index === activeIndex ? 'block' : 'none' }"
    >
      <van-field
        style="border-radius: 12px 12px 0 0"
        v-model="item.studentName"
        name="姓名"
        label="姓名"
        placeholder="姓名"
        class="must"
        input-align="right"
        error-message-align="right"
        :rules="[{ required: true, message: '请填写姓名' }]"
        @keyup="judgeDisabled"
        :class="{ activeText: item.studentName }"
        :border="false"
      />
      <van-field
        :value="item.birthday"
        name="生日"
        label="生日"
        placeholder="请选择"
        class="must"
        is-link
        input-align="right"
        error-message-align="right"
        :rules="[{ required: true, message: '请选择' }]"
        @click="showPicker = true"
        :class="{ activeText: item.birthday }"
        :border="false"
        readonly
      />
      <van-popup v-model="showPicker" position="bottom">
        <van-datetime-picker
          type="date"
          title="选择年月日"
          v-model="currentDate"
          :min-date="minDate"
          :max-date="maxDate"
          @cancel="showPicker = false"
          @confirm="onConfirm"
        />
      </van-popup>
      <van-field
        style="pointer-events: none"
        v-model="item.age"
        name="年龄"
        label="年龄"
        class="must"
        input-align="right"
        error-message-align="right"
        :rules="[{ required: true, message: '请选择' }]"
        @click="showPicker2 = true"
        :class="{ activeText: item.age }"
        :border="false"
      />
      <van-field
        :value="item.sex"
        name="性别"
        label="性别"
        class="must"
        is-link
        input-align="right"
        error-message-align="right"
        :rules="[{ required: true, message: '请选择' }]"
        @click="showPicker2 = true"
        :class="{ activeText: item.sex }"
        :border="false"
        readonly
      />
      <van-popup v-model="showPicker2" position="bottom">
        <van-picker
          title="性别"
          v-model="item.sex"
          show-toolbar
          :columns="columns2"
          @confirm="onConfirm2"
          @cancel="showPicker2 = false"
        />
      </van-popup>
      <van-field
        :value="item.relation"
        name="您与患儿的关系"
        label-width="140px"
        label="您与患儿的关系"
        placeholder="请选择"
        class="must"
        is-link
        input-align="right"
        error-message-align="right"
        :rules="[{ required: true, message: '请选择' }]"
        @click="showPicker3 = true"
        :class="{ activeText: item.relation }"
        :border="false"
        readonly
      />
      <van-popup v-model="showPicker3" position="bottom">
        <van-picker
          title="关系"
          v-model="item.relation"
          show-toolbar
          :columns="columns3"
          @confirm="onConfirm3"
          @cancel="showPicker3 = false"
        />
      </van-popup>
      <van-field
        label-width="80px"
        readonly
        clickable
        name="area"
        :value="item.address"
        label="所在城市"
        is-link
        input-align="right"
        error-message-align="right"
        placeholder="省市区"
        @click="showArea = true"
        :class="{ activeText: item.address }"
        :border="false"
      />
      <van-popup v-model="showArea" position="bottom">
        <van-area
          :area-list="areaList"
          @confirm="onConfirm4"
          @cancel="showArea = false"
        />
      </van-popup>
      <van-field
        :value="item.diagnosisFlag"
        name="是否确诊"
        label="是否确诊"
        placeholder="请选择"
        class="must"
        :class="{ activeText: item.diagnosisFlag }"
        is-link
        input-align="right"
        error-message-align="right"
        :rules="[{ required: true, message: '请选择' }]"
        @click="showPicker5 = true"
        :border="false"
        readonly
      />
      <van-popup v-model="showPicker5" position="bottom">
        <van-picker
          show-toolbar
          :columns="columns"
          @confirm="onConfirm5"
          @cancel="showPicker5 = false"
        />
      </van-popup>
      <van-field
        v-show="item.diagnosisFlag === '是'"
        style="padding: 8px 16px 20px 16px"
        :value="item.diagnosisSymptoms"
        name="确诊疾病"
        label="确诊疾病"
        placeholder="请选择"
        class="must"
        is-link
        input-align="right"
        error-message-align="right"
        :rules="[{ required: true, message: '请选择' }]"
        :class="{ activeText: item.diagnosisSymptoms }"
        @click="showPicker8 = true"
        :border="false"
        readonly
      />
      <van-popup
        v-model="showPicker8"
        position="bottom"
        @click-overlay="closeDiagnosis"
      >
        <p class="title">确诊疾病</p>
        <div class="content">
          <div
            v-for="(item, index) in diagnosisSymptomData"
            :key="index"
            :class="{ active: item.active }"
            @click="
              item.active = !item.active;
              judgeDisabled();
            "
          >
            {{ item.name }}
          </div>
        </div>
        <div class="btns" @click="closeDiagnosis">确定</div>
      </van-popup>
      <template v-if="item.diagnosisFlag === '否'">
        <p class="msg">（请至少选择一个表症）</p>
        <van-field
          :value="item.behavioralExpression.motorSymptoms"
          :class="{ active: item.behavioralExpression.motorSymptoms }"
          name="运动"
          label="运动"
          placeholder="请选择"
          is-link
          class="extraBg custom"
          type="textarea"
          autosize
          input-align="right"
          error-message-align="right"
          @click="showPicker9 = true"
        />
        <van-popup
          v-model="showPicker9"
          position="bottom"
          @click-overlay="closeMotorSymptoms"
        >
          <p class="title">运动表症</p>
          <div class="content">
            <div
              v-for="(item, index) in motorSymptomsData"
              :key="index"
              :class="{ active: item.active }"
              @click="item.active = !item.active"
            >
              {{ item.name }}
            </div>
          </div>
          <div class="btns" @click="closeMotorSymptoms">确定</div>
        </van-popup>
        <div class="empty"></div>
        <van-field
          v-model="item.behavioralExpression.languageSymptoms"
          class="extraBg custom"
          name="语言"
          label="语言"
          :class="{ active: item.behavioralExpression.languageSymptoms }"
          placeholder="请选择"
          is-link
          input-align="right"
          error-message-align="right"
          type="textarea"
          autosize
          @click="showPicker10 = true"
        />
        <van-popup
          v-model="showPicker10"
          position="bottom"
          @click-overlay="closeLanguageSymptoms"
        >
          <p class="title">语言表症</p>
          <div class="content">
            <div
              v-for="(item, index) in languageSymptomsData"
              :key="index"
              :class="{ active: item.active }"
              @click="item.active = !item.active"
            >
              {{ item.name }}
            </div>
          </div>
          <div class="btns" @click="closeLanguageSymptoms">确定</div>
        </van-popup>
        <div class="empty"></div>
        <van-field
          v-model="item.behavioralExpression.jobSymptoms"
          class="extraBg custom"
          name="作业"
          label="作业"
          :class="{ active: item.behavioralExpression.jobSymptoms }"
          placeholder="请选择"
          is-link
          input-align="right"
          error-message-align="right"
          @click="showPicker11 = true"
          type="textarea"
          autosize
        />
        <van-popup
          v-model="showPicker11"
          position="bottom"
          @click-overlay="closeJobSymptoms"
        >
          <p class="title">作业表症</p>
          <div class="content">
            <div
              v-for="(item, index) in jobSymptomsData"
              :key="index"
              :class="{ active: item.active }"
              @click="item.active = !item.active"
            >
              {{ item.name }}
            </div>
          </div>
          <div class="btns" @click="closeJobSymptoms">确定</div>
        </van-popup>
        <div class="empty"></div>
        <van-field
          :value="item.behavioralExpression.behavioralSymptoms"
          :class="{ active: item.behavioralExpression.behavioralSymptoms }"
          class="extraBg custom"
          name="心理"
          label="心理"
          placeholder="请选择"
          is-link
          input-align="right"
          error-message-align="right"
          @click="showPicker12 = true"
          type="textarea"
          autosize
        />
        <van-popup
          v-model="showPicker12"
          position="bottom"
          @click-overlay="closeBehavioralSymptomsData"
        >
          <p class="title">心理表症</p>
          <div class="content">
            <div
              v-for="(item, index) in behavioralSymptomsData"
              :key="index"
              :class="{ active: item.active }"
              @click="item.active = !item.active"
            >
              {{ item.name }}
            </div>
          </div>
          <div class="btns" @click="closeBehavioralSymptomsData">确定</div>
        </van-popup>
        <div class="empty"></div>
        <van-field
          :value="item.behavioralExpression.intellectualSymptoms"
          class="extraBg custom"
          name="特殊教育"
          label="特殊教育"
          placeholder="请选择"
          is-link
          input-align="right"
          error-message-align="right"
          type="textarea"
          @click="showPicker14 = true"
          :class="{ active: item.behavioralExpression.intellectualSymptoms }"
          autosize
        />
        <van-popup
          v-model="showPicker14"
          position="bottom"
          @click-overlay="closeIntellectualSymptomsData"
        >
          <p class="title">特殊教育表症</p>
          <div class="content">
            <div
              v-for="(item, index) in intellectualSymptomsData"
              :key="index"
              :class="{ active: item.active }"
              @click="item.active = !item.active"
            >
              {{ item.name }}
            </div>
          </div>
          <div class="btns" @click="closeIntellectualSymptomsData">确定</div>
        </van-popup>
        <div class="empty"></div>
        <van-field
          :value="item.behavioralExpression.parentingSymptoms"
          class="extraBg custom"
          name="养育"
          label="养育"
          :class="{ active: item.behavioralExpression.parentingSymptoms }"
          placeholder="请选择"
          is-link
          input-align="right"
          error-message-align="right"
          @click="showPicker13 = true"
          type="textarea"
          autosize
        />
        <van-popup
          v-model="showPicker13"
          position="bottom"
          @click-overlay="closeParentingSymptomsData"
        >
          <p class="title">养育表症</p>
          <div class="content">
            <div
              v-for="(item, index) in parentingSymptomsData"
              :key="index"
              :class="{ active: item.active }"
              @click="item.active = !item.active"
            >
              {{ item.name }}
            </div>
          </div>
          <div class="btns" @click="closeParentingSymptomsData">确定</div>
        </van-popup>
        <div class="empty empty40"></div>
      </template>
      <van-field
        :value="item.presentIllness"
        name="现病史"
        label="现病史"
        placeholder="请选择"
        is-link
        @click="chooseDiseaseMethod(1)"
        class="custom clrBot"
        type="textarea"
        readonly
        autosize
        :class="{
          activeText: item.presentIllness,
          clrTop: item.diagnosisFlag === '是',
        }"
        :border="false"
      />

      <!-- <van-popup
        v-model="showPicker6"
        position="bottom"
        @click-overlay="closeIll"
      >
        <p class="title">现病史</p>
        <div class="content">
          <div
            v-for="(item, index) in IllnessData"
            :key="index"
            :class="{ active: item.active }"
            @click="item.active = !item.active"
          >
            {{ item.name }}
          </div>
        </div>
        <div class="btns" @click="closeIll">确定</div>
      </van-popup> -->
      <van-field
        v-model="item.familyHistory"
        name="家族史"
        label="家族史"
        placeholder="请选择"
        class="custom clrTop clrBot"
        type="textarea"
        is-link
        @click="chooseDiseaseMethod(2)"
        autosize
        readonly
        :class="{ activeText: item.familyHistory }"
        :border="false"
      />
      <van-popup
        v-model="showPicker7"
        position="bottom"
        @click-overlay="closeHistor"
      >
        <p class="title">家族史</p>
        <div class="content">
          <div
            v-for="(item, index) in medicalHistoryData"
            :key="index"
            :class="{ active: item.active }"
            @click="item.active = !item.active"
          >
            {{ item.name }}
          </div>
        </div>
        <div class="btns" @click="closeHistor">确定</div>
      </van-popup>
      <div style="position: relative">
        <van-field
          v-model="item.remark"
          class="normal"
          label="备注："
          type="textarea"
          label-width="60px"
          maxlength="50"
          placeholder="备注内容"
          show-word-limit
          style="border-radius: 0px 0px 12px 12px; padding-top: 0"
        />
        <div
          class="remove"
          v-if="studentList.length > 1"
          @click="removeStudent(index)"
        >
          <img :src="deletePic" alt="" />
          <span>删除档案</span>
        </div>
      </div>
      <div></div>
      <div class="buttonBottom">
        <van-button
          class="buttonBottom_left"
          round
          block
          type="info"
          :disabled="isDisabled"
          @click="addData"
          >新增儿童</van-button
        >
        <van-button
          class="buttonBottom_right"
          round
          block
          type="info"
          native-type="submit"
          :disabled="isDisabled"
          @click="jumpTo"
          >保存</van-button
        >
      </div>
      <div v-if="showLoading" class="loading">
        <van-loading color="#1989fa" />
      </div>
    </van-form>
    <van-action-sheet
      v-model="showChoice"
      title="请选择"
      :visible.sync="showChoice"
      :lock-scroll="false"
      v-if="showChoice"
      :get-container="getContainer"
    >
      <div class="content">
        <Choice
          :onlineChild="columnsIll"
          :typeRecord="typeRecord"
          :onClass="onClass"
          :sourceFlag="sourceFlag"
          :currentName="currentName"
          @getChoiceData="getChoiceData"
          :apiType="chooseType"
        />
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
import {
  _relation,
  _addOrEdit,
  _childDetail,
  _getUser,
} from "../../../api/login";
import { areaList } from "@vant/area-data";
import { decryptBy, encryptBy } from "@/assets/js/encryption";
import Cookies from "js-cookie";
import Choice from "./choice.vue";
export default {
  name: "",
  components: { Choice },
  data() {
    return {
      chooseType: "",
      showLoading: false,
      isDisabled: true,
      add: require("../../../assets/images/login/add.png"),
      home: require("../../../assets/images/login/enable-home.png"),
      arrow: require("../../../assets/images/login/arrow-right.png"),
      deletePic: require("../../../assets/images/login/delete.png"),
      currentDate: new Date(),
      minDate: new Date(1900, 0, 1),
      maxDate: new Date(),
      // 是否确诊
      value: "",
      columns: ["是", "否"],
      columns2: ["男", "女"],
      columns3: [],
      totalRelation: [], // 关系数据
      showPicker: false,
      showPicker1: false,
      showPicker2: false,
      showPicker3: false,
      showPicker5: false,
      showPicker6: false,
      showPicker7: false,
      showPicker8: false,
      showPicker9: false,
      showPicker10: false,
      showPicker11: false,
      showPicker12: false,
      showPicker13: false,
      showPicker14: false,
      activeIndex: 0,
      studentList: [
        {
          studentName: "", // 儿童姓名
          birthday: "", // 儿童出生日期
          age: "",
          sex: "", // 儿童性别
          relation: "", // 与孩子的关系
          relationNo: "", // 关系编码
          diagnosisFlag: "", // 是否确诊
          diagnosisSymptoms: "", // 确诊症状 后台需要数组
          presentIllnessData: [],
          familyHistoryData: [],
          familyHistory: "", //家族史
          presentIllness: "", // 现病史
          behavioralExpression: {
            motorSymptoms: "", // 运动
            languageSymptoms: "", // 语言
            jobSymptoms: "", // 作业
            behavioralSymptoms: "", // 心理
            parentingSymptoms: "", // 养育
            intellectualSymptoms: "", // 智力低下
          },
          remark: "", // 备注
        },
      ], // 儿童信息
      areaList, //省市区数据
      showArea: false, //选择省市区弹窗标识
      values: [], //选择的省市区列表 含code与name
      totalIllness: [], //现病史数据
      IllnessData: [],
      totalMedicalHistory: [], //家族史数据
      medicalHistoryData: [],
      totalDiagnosisSymptom: [], // 疾病数据
      diagnosisSymptomData: [],
      totalMotorSymptoms: [], // 运动数据
      motorSymptomsData: [], //
      totalLanguageSymptoms: [], //语言数据
      languageSymptomsData: [], //
      totalJobSymptoms: [], //作业数据
      jobSymptomsData: [],
      totalbehavioralSymptoms: [], // 心理
      behavioralSymptomsData: [],
      totalParentingSymptoms: [], // 养育
      parentingSymptomsData: [],
      totalIntellectualSymptoms: [], //智力低下
      intellectualSymptomsData: [],
      // 疾病
      dieaseList: [],
      sourceFlag: "2",
      columnsIll: [],
      showChoice: false,
      currentDiseaseName: [],
      typeRecord: "currentDisease",
      onClass: "current",
      currentName: [],
      currentDisease: "",
      currentDiseaseOrigin: "",
      selectArr: [], //选择的疾病
      showWu: true,
      popDivContainer: null,
    };
  },
  methods: {
    getContainer() {
      return this.popDivContainer;
    },
    // 确定选择疾病了
    getChoiceData(val, nameArr, num) {
      if (!val.length) {
        val = [
          {
            id: "wu",
            name: "无",
            source: "",
            status: true,
          },
        ];
        nameArr = ["无"];
      }
      let arr = [];
      val.forEach((item) => {
        arr.push({ label: item.name, code: item.id });
      });
      // 只处理了现病史
      if (this.chooseType === 1) {
        this.$set(
          this.studentList[this.activeIndex],
          "presentIllness",
          nameArr.join(",")
        );
        this.$set(
          this.studentList[this.activeIndex],
          "presentIllnessData",
          arr
        );
      } else {
        this.$set(
          this.studentList[this.activeIndex],
          "familyHistory",
          nameArr.join(",")
        );
        this.$set(this.studentList[this.activeIndex], "familyHistoryData", arr);
      }
      this.showChoice = false;
    },
    chooseDiseaseMethod(type) {
      this.chooseType = type;
      let nameList = [];
      if (type == 1) {
        this.studentList[this.activeIndex].presentIllnessData.forEach(
          (item) => {
            nameList.push(item.label);
          }
        );
      } else {
        this.studentList[this.activeIndex].familyHistoryData.forEach((item) => {
          nameList.push(item.label);
        });
      }
      // 用于回显
      // if(nameList.length===0){ nameList=['无']}
      this.currentName = nameList;
      // str 列表数据
      let str = "";
      if (type === 1) {
        if (this.studentList[this.activeIndex].presentIllnessData) {
          this.studentList[this.activeIndex].presentIllnessData.forEach(
            (item) => {
              str += `${item.code}|${item.label}^`;
            }
          );
        }
      } else {
        this.studentList[this.activeIndex].familyHistoryData.forEach((item) => {
          str += `${item.code}|${item.label}^`;
        });
      }
      this.columnsIll = this.formatArr(str);
      this.showChoice = true;
    },
    formatArr(str) {
      if (!str)
        return [
          {
            id: "wu",
            name: "无",
          },
        ];
      let tempStr = str;
      if (str.indexOf("wu") === -1) {
        tempStr = "wu|无^" + str;
      }
      return (
        tempStr &&
        tempStr.split("^").map((item) => {
          const arr = item.split("|");
          return {
            id: arr[0],
            name: arr[1],
          };
        })
      );
    },
    // 关系
    getRelationShip() {
      _relation({
        code: "relationShip",
      }).then((res) => {
        if (res && res.code == 200) {
          this.totalRelation = res.data;
          this.columns3 = this.totalRelation.map((item) => item.name);
        } else {
          this.$toast(res.message);
        }
      });
    },
    getDiagnosisSymptom() {
      _relation({
        code: "diagnosisSymptom",
      }).then((res) => {
        if (res && res.code == 200) {
          this.totalDiagnosisSymptom = res.data;
          this.diagnosisSymptomData = this.totalDiagnosisSymptom.map((item) => {
            return { name: item.name, active: false, code: item.code };
          });
        } else {
          this.$toast(res.message);
        }
      });
    },
    getPresentIllness() {
      _relation({
        code: "presentIllness",
      }).then((res) => {
        if (res && res.code == 200) {
          this.totalIllness = res.data;
          let data = this.totalIllness.filter((item) => item.name != "无");
          this.IllnessData = data.map((item) => {
            return { name: item.name, active: false, code: item.code };
          });
        } else {
          this.$toast(res.message);
        }
      });
    },
    getFamilyMedicalHistory() {
      _relation({
        code: "familyMedicalHistory",
      }).then((res) => {
        if (res && res.code == 200) {
          this.totalMedicalHistory = res.data;
          let data = this.totalMedicalHistory.filter(
            (item) => item.name != "无"
          );
          this.medicalHistoryData = data.map((item) => {
            return { name: item.name, active: false, code: item.code };
          });
        }
      });
    },
    // 根据日期计算年龄
    toAge(birthday) {
      //根据日期算年龄
      if (birthday) {
        birthday = birthday.split("-");
        // 新建日期对象
        let date = new Date();
        // 今天日期，数组，同 birthday
        let today = [date.getFullYear(), date.getMonth() + 1, date.getDate()];
        // 分别计算年月日差值
        let age = today.map((val, index) => {
          return val - birthday[index];
        });
        // 当天数为负数时，月减 1，天数加上月总天数
        if (age[2] < 0) {
          // 简单获取上个月总天数的方法，不会错
          let lastMonth = new Date(today[0], today[1], 0);
          age[1]--;
          age[2] += lastMonth.getDate();
        }
        // 当月数为负数时，年减 1，月数加上 12
        if (age[1] < 0) {
          age[0]--;
          age[1] += 12;
        }
        console.log(age[0] + "岁" + age[1] + "月" + age[2] + "天");
        return age[0];
      }
    },
    // 生日弹框
    onConfirm(value) {
      let date = this.currentDate;
      let year = date.getFullYear(); //年
      let month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1; //月
      let strDate = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      this.birth = `${year}-${month}-${strDate}`;
      this.$set(this.studentList[this.activeIndex], "birthday", this.birth);
      this.$set(
        this.studentList[this.activeIndex],
        "age",
        this.toAge(this.birth)
      );
      this.showPicker = false;
      this.judgeDisabled();
    },
    onConfirm2(value) {
      // this.diease = value;
      this.$set(this.studentList[this.activeIndex], "sex", value);
      this.showPicker2 = false;
      this.judgeDisabled();
    },
    // 关系弹框
    onConfirm3(value) {
      this.$set(this.studentList[this.activeIndex], "relation", value);
      let relationNo = this.totalRelation.find(
        (item) => item.name == value
      ).code;
      this.$set(this.studentList[this.activeIndex], "relationNo", relationNo);
      this.showPicker3 = false;
      this.judgeDisabled();
    },
    //省市区弹窗选择
    onConfirm4(value) {
      let address = value
        .filter((item) => !!item)
        .map((item) => item.name)
        .join(" ");
      this.$set(this.studentList[this.activeIndex], "address", address);
      this.$set(this.studentList[this.activeIndex], "province", value[0].name);
      this.$set(
        this.studentList[this.activeIndex],
        "provinceCode",
        value[0].code
      );
      this.$set(this.studentList[this.activeIndex], "city", value[1].name);
      this.$set(this.studentList[this.activeIndex], "cityCode", value[1].code);
      this.$set(this.studentList[this.activeIndex], "county", value[2].name);
      this.$set(
        this.studentList[this.activeIndex],
        "countyCode",
        value[2].code
      );

      this.values = value;
      this.showArea = false;
    },
    onConfirm5(value) {
      this.$set(this.studentList[this.activeIndex], "diagnosisFlag", value);
      this.showPicker5 = false;
      if (value === "是") {
        this.getDiagnosisSymptom();
        this.$set(
          this.studentList[this.activeIndex].behavioralExpression,
          "motorSymptoms",
          ""
        );
        this.$set(
          this.studentList[this.activeIndex].behavioralExpression,
          "languageSymptoms",
          ""
        );
        this.$set(
          this.studentList[this.activeIndex].behavioralExpression,
          "jobSymptoms",
          ""
        );
        this.$set(
          this.studentList[this.activeIndex].behavioralExpression,
          "behavioralSymptoms",
          ""
        );
        this.$set(
          this.studentList[this.activeIndex].behavioralExpression,
          "parentingSymptoms",
          ""
        );
        this.$set(
          this.studentList[this.activeIndex].behavioralExpression,
          "intellectualSymptoms",
          ""
        );
      } else {
        this.$set(this.studentList[this.activeIndex], "diagnosisSymptoms", "");
        // 运动
        this.getMotorSymptoms();
        // 语言
        this.getLanguageSymptoms();
        //  作业
        this.getJobSymptoms();
        // 心理
        this.getBehavioralSymptoms();
        // 养育
        this.getParentingSymptoms();
        // 智力低下
        this.getIntellectualSymptoms();
      }
      this.judgeDisabled();
    },
    getMotorSymptoms() {
      _relation({
        code: "motorSymptoms",
      }).then((res) => {
        if (res && res.code == 200) {
          this.totalMotorSymptoms = res.data;
          this.motorSymptomsData = this.totalMotorSymptoms.map((item) => {
            return { name: item.name, active: false, code: item.code };
          });
        } else {
          this.$toast(res.message);
        }
      });
    },
    getLanguageSymptoms() {
      _relation({
        code: "languageSymptoms",
      }).then((res) => {
        if (res && res.code == 200) {
          this.totalLanguageSymptoms = res.data;
          this.languageSymptomsData = this.totalLanguageSymptoms.map((item) => {
            return { name: item.name, active: false, code: item.code };
          });
        } else {
          this.$toast(res.message);
        }
      });
    },
    getJobSymptoms() {
      _relation({
        code: "jobSymptoms",
      }).then((res) => {
        if (res && res.code == 200) {
          this.totalJobSymptoms = res.data;
          this.jobSymptomsData = this.totalJobSymptoms.map((item) => {
            return { name: item.name, active: false, code: item.code };
          });
        } else {
          this.$toast(res.message);
        }
      });
    },
    getBehavioralSymptoms() {
      _relation({
        code: "behavioralSymptoms",
      }).then((res) => {
        if (res && res.code == 200) {
          this.totalBehavioralSymptoms = res.data;
          this.behavioralSymptomsData = this.totalBehavioralSymptoms.map(
            (item) => {
              return { name: item.name, active: false, code: item.code };
            }
          );
        } else {
          this.$toast(res.message);
        }
      });
    },
    getParentingSymptoms() {
      _relation({
        code: "parentingSymptoms",
      }).then((res) => {
        if (res && res.code == 200) {
          this.totalParentingSymptoms = res.data;
          this.parentingSymptomsData = this.totalParentingSymptoms.map(
            (item) => {
              return { name: item.name, active: false, code: item.code };
            }
          );
        } else {
          this.$toast(res.message);
        }
      });
    },
    getIntellectualSymptoms() {
      _relation({
        code: "intellectualDisabilitySymptoms",
      }).then((res) => {
        if (res && res.code == 200) {
          this.totalIntellectualSymptoms = res.data;
          this.intellectualSymptomsData = this.totalIntellectualSymptoms.map(
            (item) => {
              return { name: item.name, active: false, code: item.code };
            }
          );
        } else {
          this.$toast(res.message);
        }
      });
    },
    closeDiagnosis() {
      this.showPicker8 = false;
      let scopeName = this.diagnosisSymptomData
        .filter((item) => item.active == true)
        .map((item) => item.name)
        .join(",");
      this.$set(
        this.studentList[this.activeIndex],
        "diagnosisSymptoms",
        scopeName
      );
      this.judgeDisabled();
    },
    closeIll() {
      this.showPicker6 = false;
      let scopeName = this.IllnessData.filter((item) => item.active == true)
        .map((item) => item.name)
        .join(",");
      this.$set(
        this.studentList[this.activeIndex],
        "presentIllness",
        scopeName
      );
      this.judgeDisabled();
    },
    closeHistor() {
      this.showPicker7 = false;
      let familyHistory = this.medicalHistoryData
        .filter((item) => item.active == true)
        .map((item) => item.name)
        .join(",");
      this.$set(
        this.studentList[this.activeIndex],
        "familyHistory",
        familyHistory
      );
      this.judgeDisabled();
    },
    closeMotorSymptoms() {
      this.showPicker9 = false;
      let familyHistory = this.motorSymptomsData
        .filter((item) => item.active == true)
        .map((item) => item.name)
        .join(",");
      this.$set(
        this.studentList[this.activeIndex].behavioralExpression,
        "motorSymptoms",
        familyHistory
      );
      this.judgeDisabled();
    },
    closeLanguageSymptoms() {
      this.showPicker10 = false;
      let familyHistory = this.languageSymptomsData
        .filter((item) => item.active == true)
        .map((item) => item.name)
        .join(",");
      this.$set(
        this.studentList[this.activeIndex].behavioralExpression,
        "languageSymptoms",
        familyHistory
      );
      this.judgeDisabled();
    },
    closeJobSymptoms() {
      this.showPicker11 = false;
      let familyHistory = this.jobSymptomsData
        .filter((item) => item.active == true)
        .map((item) => item.name)
        .join(",");
      this.$set(
        this.studentList[this.activeIndex].behavioralExpression,
        "jobSymptoms",
        familyHistory
      );
      this.judgeDisabled();
    },
    closeBehavioralSymptomsData() {
      this.showPicker12 = false;
      let familyHistory = this.behavioralSymptomsData
        .filter((item) => item.active == true)
        .map((item) => item.name)
        .join(",");
      this.$set(
        this.studentList[this.activeIndex].behavioralExpression,
        "behavioralSymptoms",
        familyHistory
      );
      this.judgeDisabled();
    },
    closeParentingSymptomsData() {
      this.showPicker13 = false;
      let familyHistory = this.parentingSymptomsData
        .filter((item) => item.active == true)
        .map((item) => item.name)
        .join(",");
      this.$set(
        this.studentList[this.activeIndex].behavioralExpression,
        "parentingSymptoms",
        familyHistory
      );
      this.judgeDisabled();
    },
    closeIntellectualSymptomsData() {
      this.showPicker14 = false;
      let familyHistory = this.intellectualSymptomsData
        .filter((item) => item.active == true)
        .map((item) => item.name)
        .join(",");
      this.$set(
        this.studentList[this.activeIndex].behavioralExpression,
        "intellectualSymptoms",
        familyHistory
      );
      this.judgeDisabled();
    },
    updateUser() {
      _getUser({
        authentication: Cookies.get("token"),
      }).then((res) => {
        if (res && res.code == 200) {
          this.$store.commit("USER_INFO", res.data);
          localStorage.setItem("userInfo", encryptBy(JSON.stringify(res.data)));
          this.$router.replace("/");
        } else {
          this.$toast(res.message);
        }
      });
    },
    jumpTo() {
      let students = JSON.parse(JSON.stringify(this.studentList));
      students.forEach((list, index) => {
        list.diagnosisFlag = list.diagnosisFlag === "是" ? "1" : "0";
        if (list.diagnosisFlag == "0") {
          list.diagnosisSymptoms = [];
          if (list.behavioralExpression.motorSymptoms) {
            let name = list.behavioralExpression.motorSymptoms;
            list.behavioralExpression.motorSymptoms = [];
            let motorSymptoms = name.split(",");
            this.motorSymptomsData.forEach((element) => {
              motorSymptoms.forEach((name) => {
                if (element.name === name) {
                  list.behavioralExpression.motorSymptoms.push({
                    label: name,
                    code: element.code,
                  });
                }
              });
            });
          } else {
            list.behavioralExpression.motorSymptoms = [];
          }
          if (list.behavioralExpression.languageSymptoms) {
            let name = list.behavioralExpression.languageSymptoms;
            list.behavioralExpression.languageSymptoms = [];
            let motorSymptoms = name.split(",");
            this.languageSymptomsData.forEach((element) => {
              motorSymptoms.forEach((name) => {
                if (element.name === name) {
                  list.behavioralExpression.languageSymptoms.push({
                    label: name,
                    code: element.code,
                  });
                }
              });
            });
          } else {
            list.behavioralExpression.languageSymptoms = [];
          }
          if (list.behavioralExpression.jobSymptoms) {
            let name = list.behavioralExpression.jobSymptoms;
            list.behavioralExpression.jobSymptoms = [];
            let motorSymptoms = name.split(",");
            this.jobSymptomsData.forEach((element) => {
              motorSymptoms.forEach((name) => {
                if (element.name === name) {
                  list.behavioralExpression.jobSymptoms.push({
                    label: name,
                    code: element.code,
                  });
                }
              });
            });
          } else {
            list.behavioralExpression.jobSymptoms = [];
          }
          if (list.behavioralExpression.behavioralSymptoms) {
            let name = list.behavioralExpression.behavioralSymptoms;
            list.behavioralExpression.behavioralSymptoms = [];
            let motorSymptoms = name.split(",");
            this.behavioralSymptomsData.forEach((element) => {
              motorSymptoms.forEach((name) => {
                if (element.name === name) {
                  list.behavioralExpression.behavioralSymptoms.push({
                    label: name,
                    code: element.code,
                  });
                }
              });
            });
          } else {
            list.behavioralExpression.behavioralSymptoms = [];
          }
          if (list.behavioralExpression.parentingSymptoms) {
            let name = list.behavioralExpression.parentingSymptoms;
            list.behavioralExpression.parentingSymptoms = [];
            let motorSymptoms = name.split(",");
            this.parentingSymptomsData.forEach((element) => {
              motorSymptoms.forEach((name) => {
                if (element.name === name) {
                  list.behavioralExpression.parentingSymptoms.push({
                    label: name,
                    code: element.code,
                  });
                }
              });
            });
          } else {
            list.behavioralExpression.parentingSymptoms = [];
          }
          if (list.behavioralExpression.intellectualSymptoms) {
            let name = list.behavioralExpression.intellectualSymptoms;
            list.behavioralExpression.intellectualSymptoms = [];
            list.behavioralExpression.intellectualDisabilitySymptoms = [];
            let motorSymptoms = name.split(",");
            this.intellectualSymptomsData.forEach((element) => {
              motorSymptoms.forEach((name) => {
                if (element.name === name) {
                  list.behavioralExpression.intellectualSymptoms.push({
                    label: name,
                    code: element.code,
                  });
                  list.behavioralExpression.intellectualDisabilitySymptoms.push(
                    {
                      label: name,
                      code: element.code,
                    }
                  );
                }
              });
            });
          } else {
            list.behavioralExpression.intellectualSymptoms = [];
            list.behavioralExpression.intellectualDisabilitySymptoms = [];
          }
        } else {
          list.behavioralExpression = {};
        }
        list.sex = list.sex === "男" ? "1" : "2";
        // list.relationNo = this.totalRelation.find(
        //   (item) => item.name == list.relation
        // ).code;
        // 确诊疾病
        if (list.diagnosisFlag == "1") {
          // list.diagnosisSymptoms = this.diagnosisSymptomData
          //   .filter((item) => item.active == true)
          //   .map((item) => {
          //     return { label: item.name, code: item.code };
          //   });
          let name = list.diagnosisSymptoms;
          list.diagnosisSymptoms = [];
          let motorSymptoms = name.split(",");
          this.diagnosisSymptomData.forEach((element) => {
            motorSymptoms.forEach((name) => {
              if (element.name === name) {
                list.diagnosisSymptoms.push({
                  label: name,
                  code: element.code,
                });
              }
            });
          });
        }
        // 现病史
        if (list.presentIllness) {
          // 添加的时候
          list.presentIllness = list.presentIllnessData;
          // let name = list.presentIllness;
          // list.presentIllness = [];
          // let motorSymptoms = name.split(",");
          // this.IllnessData.forEach((element) => {
          //   motorSymptoms.forEach((name) => {
          //     if (element.name === name) {
          //       list.presentIllness.push({
          //         label: name,
          //         code: element.code,
          //       });
          //     }
          //   });
          // });
          // list.presentIllness = this.IllnessData.filter(
          //   (item) => item.active == true
          // ).map((item) => {
          //   return { label: item.name, code: item.code };
          // });
        } else {
          delete list.presentIllness;
        }
        if (list.familyHistory) {
          list.familyHistory = list.familyHistoryData;
          // list.familyHistory = this.medicalHistoryData
          //   .filter((item) => item.active == true)
          //   .map((item) => {
          //     return { label: item.name, code: item.code };
          //   });
          // let name = list.familyHistory;
          // list.familyHistory = [];
          // let motorSymptoms = name.split(",");
          // this.medicalHistoryData.forEach((element) => {
          //   motorSymptoms.forEach((name) => {
          //     if (element.name === name) {
          //       list.familyHistory.push({
          //         label: name,
          //         code: element.code,
          //       });
          //     }
          //   });
          // });
        } else {
          delete list.familyHistory;
        }
        // 防止没有选择 直接提交
        // if (list.address && this.values.length > 0) {
        //   let address = list.address.split(" ");
        //   let provinceObj = this.values.find(
        //     (item) => item.name === address[0]
        //   );
        //   let cityObj = {};
        //   this.values.forEach((item) => {
        //     if (item.name === address[1]) {
        //       cityObj = item;
        //     }
        //   });
        //   let areaObj = this.values.find((item) => item.name === address[2]);
        //   list.province = provinceObj ? provinceObj.name : "";
        //   list.provinceCode = provinceObj ? provinceObj.code : "";
        //   list.city = cityObj ? cityObj.name : "";
        //   list.cityCode = cityObj ? cityObj.code : "";
        //   list.county = areaObj ? areaObj.name : "";
        //   list.countyCode = areaObj ? areaObj.code : "";
        // } else {
        //   delete list.address;
        // }
      });
      this.showLoading = true;
      _addOrEdit(students)
        .then((res) => {
          if (res && res.code === 200) {
            this.updateUser();
          } else {
            this.$toast(res.message);
          }
          this.showLoading = false;
        })
        .catch((err) => {
          this.showLoading = false;
        });
      // studentList: [
      //   {
      //     id: 0, // 标识
      //     showRelationship: false, //

      //     studentName: "", // 儿童姓名
      //     birthday: "", // 儿童出生日期
      //     age: "",
      //     sex: "", // 儿童性别
      //     relation: "", // 与孩子的关系
      //     relationNo: "", // 关系编码
      //     diagnosisFlag: "", // 是否确诊
      //     diagnosisSymptoms: "", // 确诊症状 后台需要数组
      //     familyHistory: "", //家族史
      //     presentIllness: "", // 现病史
      //     behavioralExpression: {
      //       languageSymptoms: [], // 语言
      //       motorSymptoms: [], // 运动
      //       jobSymptoms: [], // 作业
      //       behavioralSymptoms: [], // 行为
      //     },
      //     remark: "", // 备注
      //   },
      // ],
    },
    onSubmit(values) {
      console.log("submit", values);
    },
    judgeDisabled() {
      if (this.studentList[this.activeIndex].diagnosisFlag === "是") {
        this.isDisabled = !(
          this.studentList[this.activeIndex].studentName &&
          this.studentList[this.activeIndex].birthday &&
          this.studentList[this.activeIndex].sex &&
          String(this.studentList[this.activeIndex].age) &&
          this.studentList[this.activeIndex].relation &&
          this.studentList[this.activeIndex].diagnosisSymptoms
        );
      } else if (this.studentList[this.activeIndex].diagnosisFlag === "否") {
        let ltOne =
          this.studentList[this.activeIndex].behavioralExpression
            .motorSymptoms ||
          this.studentList[this.activeIndex].behavioralExpression
            .languageSymptoms ||
          this.studentList[this.activeIndex].behavioralExpression.jobSymptoms ||
          this.studentList[this.activeIndex].behavioralExpression
            .behavioralSymptoms ||
          this.studentList[this.activeIndex].behavioralExpression
            .parentingSymptoms ||
          this.studentList[this.activeIndex].behavioralExpression
            .intellectualSymptoms;
        this.isDisabled = !(
          this.studentList[this.activeIndex].studentName &&
          this.studentList[this.activeIndex].birthday &&
          this.studentList[this.activeIndex].age &&
          this.studentList[this.activeIndex].sex &&
          this.studentList[this.activeIndex].relation &&
          ltOne
        );
      } else {
        this.isDisabled = true;
      }
      console.log("当前禁用", this.isDisabled);
    },
    addData() {
      this.activeIndex = this.studentList.length;
      this.isDisabled = true;
      this.diagnosisSymptomData.forEach((item) => {
        item.active = false;
      });
      this.IllnessData.forEach((item) => {
        item.active = false;
      });
      this.medicalHistoryData.forEach((item) => {
        item.active = false;
      });
      this.motorSymptomsData.forEach((item) => {
        item.active = false;
      });
      this.languageSymptomsData.forEach((item) => {
        item.active = false;
      });
      this.jobSymptomsData.forEach((item) => {
        item.active = false;
      });
      this.behavioralSymptomsData.forEach((item) => {
        item.active = false;
      });
      this.parentingSymptomsData.forEach((item) => {
        item.active = false;
      });
      this.intellectualSymptomsData.forEach((item) => {
        item.active = false;
      });
      this.studentList.push({
        studentName: "", // 儿童姓名
        birthday: "", // 儿童出生日期
        age: "",
        sex: "", // 儿童性别
        relation: "", // 与孩子的关系
        relationNo: "", // 关系编码
        address: "",
        diagnosisFlag: "", // 是否确诊
        diagnosisSymptoms: "", // 确诊症状 后台需要数组
        familyHistory: "", //家族史
        presentIllness: "", // 现病史
        presentIllnessData: [],
        familyHistoryData: [],
        behavioralExpression: {
          motorSymptoms: "", // 运动
          languageSymptoms: "", // 语言
          jobSymptoms: "", // 作业
          behavioralSymptoms: "", // 心理
          parentingSymptoms: "", // 养育
          intellectualSymptoms: "", // 智力低下
        },
        remark: "", // 备注
      });
    },
    changeStudent(item, index) {
      if (index === this.activeIndex) return;
      if (this.isDisabled) return this.$toast("请将内容填写完毕");
      this.activeIndex = index;
      if (item.diagnosisFlag == "是") {
        this.diagnosisSymptomData.forEach((item) => {
          item.active = false;
        });
        let arr = item.diagnosisSymptoms.split(",");
        this.diagnosisSymptomData.forEach((list) => {
          // 确诊疾病
          arr.forEach((data) => {
            if (list.name === data) {
              list.active = true;
            }
          });
        });
      }
      if (item.diagnosisFlag == "否") {
        if (item.behavioralExpression.motorSymptoms) {
          let arr = item.behavioralExpression.motorSymptoms.split(",");
          this.motorSymptomsData.forEach((item) => {
            item.active = false;
          });
          this.motorSymptomsData.forEach((list) => {
            arr.forEach((data) => {
              if (list.name === data) {
                list.active = true;
              }
            });
          });
        }
        if (item.behavioralExpression.languageSymptoms) {
          let arr = item.behavioralExpression.languageSymptoms.split(",");
          this.languageSymptomsData.forEach((item) => {
            item.active = false;
          });
          this.languageSymptomsData.forEach((list) => {
            arr.forEach((data) => {
              if (list.name === data) {
                list.active = true;
              }
            });
          });
        }
        if (item.behavioralExpression.jobSymptoms) {
          let arr = item.behavioralExpression.jobSymptoms.split(",");
          this.jobSymptomsData.forEach((item) => {
            item.active = false;
          });
          this.jobSymptomsData.forEach((list) => {
            arr.forEach((data) => {
              if (list.name === data) {
                list.active = true;
              }
            });
          });
        }
        if (item.behavioralExpression.behavioralSymptoms) {
          let arr = item.behavioralExpression.behavioralSymptoms.split(",");
          this.behavioralSymptomsData.forEach((item) => {
            item.active = false;
          });
          this.behavioralSymptomsData.forEach((list) => {
            arr.forEach((data) => {
              if (list.name === data) {
                list.active = true;
              }
            });
          });
        }
        if (item.behavioralExpression.parentingSymptoms) {
          let arr = item.behavioralExpression.parentingSymptoms.split(",");
          this.parentingSymptomsData.forEach((item) => {
            item.active = false;
          });
          this.parentingSymptomsData.forEach((list) => {
            arr.forEach((data) => {
              if (list.name === data) {
                list.active = true;
              }
            });
          });
        }
        if (item.behavioralExpression.intellectualSymptoms) {
          let arr = item.behavioralExpression.intellectualSymptoms.split(",");
          this.intellectualSymptomsData.forEach((item) => {
            item.active = false;
          });
          this.intellectualSymptomsData.forEach((list) => {
            arr.forEach((data) => {
              if (list.name === data) {
                list.active = true;
              }
            });
          });
        }
        // if (item.presentIllness) {
        //   let arr = item.presentIllness.split(",");
        //   this.IllnessData.forEach((item) => {
        //     item.active = false;
        //   });
        //   this.IllnessData.forEach((list) => {
        //     // 现病史
        //     arr.forEach((data) => {
        //       if (list.name === data) {
        //         list.active = true;
        //       }
        //     });
        //   });
        // }
        // if (item.familyHistory) {
        //   let arr = item.familyHistory.split(",");
        //   this.medicalHistoryData.forEach((item) => {
        //     item.active = false;
        //   });
        //   this.medicalHistoryData.forEach((list) => {
        //     // 家族史
        //     arr.forEach((data) => {
        //       if (list.name === data) {
        //         list.active = true;
        //       }
        //     });
        //   });
        // }
      }
      this.judgeDisabled();
    },
    removeStudent(index) {
      this.values = [];
      this.studentList.splice(index, 1);
      this.activeIndex--;
      if (this.activeIndex === -1) {
        this.activeIndex = 0;
      }
      this.judgeDisabled();
    },
    getDetail() {
      _childDetail()
        .then((res) => {
          if (res && res.code === 200 && res.data) {
            let data = res.data;
            data.forEach((item, index) => {
              (item.sex = item.sex == "1" ? "男" : "女"),
                (item.address = item.province
                  ? `${item.province} ${item.city} ${item.county} `
                  : "");
              if (item.diagnosisFlag == "1" && index === 0) {
                this.diagnosisSymptomData.forEach((list) => {
                  // 确诊疾病
                  item.diagnosisSymptoms.forEach((data) => {
                    if (list.code === data.code) {
                      list.active = true;
                    }
                  });
                });
              }
              if (item.diagnosisFlag == "0") {
                if (!item.behavioralExpression.motorSymptoms) {
                  item.behavioralExpression.motorSymptoms = "";
                } else {
                  let arr = item.behavioralExpression.motorSymptoms;
                  if (index === 0) {
                    this.motorSymptomsData.forEach((item) => {
                      arr.forEach((list) => {
                        if (item.code === list.code) {
                          item.active = true;
                        }
                      });
                    });
                  }
                  item.behavioralExpression.motorSymptoms = arr
                    .map((item) => item.label)
                    .join(",");
                }
                if (!item.behavioralExpression.languageSymptoms) {
                  item.behavioralExpression.languageSymptoms = "";
                } else {
                  let arr = item.behavioralExpression.languageSymptoms;
                  if (index === 0) {
                    this.languageSymptomsData.forEach((item) => {
                      arr.forEach((list) => {
                        if (item.code === list.code) {
                          item.active = true;
                        }
                      });
                    });
                  }
                  item.behavioralExpression.languageSymptoms = arr
                    .map((item) => item.label)
                    .join(",");
                }
                if (!item.behavioralExpression.jobSymptoms) {
                  item.behavioralExpression.jobSymptoms = "";
                } else {
                  let arr = item.behavioralExpression.jobSymptoms;
                  if (index === 0) {
                    this.jobSymptomsData.forEach((item) => {
                      arr.forEach((list) => {
                        if (item.code === list.code) {
                          item.active = true;
                        }
                      });
                    });
                  }
                  item.behavioralExpression.jobSymptoms = arr
                    .map((item) => item.label)
                    .join(",");
                }
                if (!item.behavioralExpression.behavioralSymptoms) {
                  item.behavioralExpression.behavioralSymptoms = "";
                } else {
                  let arr = item.behavioralExpression.behavioralSymptoms;
                  if (index === 0) {
                    this.behavioralSymptomsData.forEach((item) => {
                      arr.forEach((list) => {
                        if (item.code === list.code) {
                          item.active = true;
                        }
                      });
                    });
                  }
                  item.behavioralExpression.behavioralSymptoms = arr
                    .map((item) => item.label)
                    .join(",");
                }
                if (!item.behavioralExpression.parentingSymptoms) {
                  item.behavioralExpression.parentingSymptoms = "";
                } else {
                  let arr = item.behavioralExpression.parentingSymptoms;
                  if (index === 0) {
                    this.parentingSymptomsData.forEach((item) => {
                      arr.forEach((list) => {
                        if (item.code === list.code) {
                          item.active = true;
                        }
                      });
                    });
                  }
                  item.behavioralExpression.parentingSymptoms = arr
                    .map((item) => item.label)
                    .join(",");
                }
                if (!item.behavioralExpression.intellectualDisabilitySymptoms) {
                  item.behavioralExpression.intellectualSymptoms = "";
                } else {
                  let arr =
                    item.behavioralExpression.intellectualDisabilitySymptoms;
                  if (index === 0) {
                    this.intellectualSymptomsData.forEach((item) => {
                      arr.forEach((list) => {
                        if (item.code === list.code) {
                          item.active = true;
                        }
                      });
                    });
                  }
                  item.behavioralExpression.intellectualSymptoms = arr
                    .map((item) => item.label)
                    .join(",");
                }
              }
              // 只处理了第一条记录中的回显
              if (index === 0) {
                // if (item.presentIllness) {
                //   this.IllnessData.forEach((list) => {
                //     // 现病史
                //     item.presentIllness.forEach((data) => {
                //       if (list.code === data.code) {
                //         list.active = true;
                //       }
                //     });
                //   });
                // }
                // if (item.familyHistory) {
                //   this.medicalHistoryData.forEach((list) => {
                //     // 家族史
                //     item.familyHistory.forEach((data) => {
                //       if (list.code === data.code) {
                //         list.active = true;
                //       }
                //     });
                //   });
                // }
              }
              if (!item.behavioralExpression) {
                item.behavioralExpression = {
                  motorSymptoms: "", // 运动
                  languageSymptoms: "", // 语言
                  jobSymptoms: "", // 作业
                  behavioralSymptoms: "", // 心理
                  parentingSymptoms: "", // 养育
                  intellectualSymptoms: "", // 智力低下
                };
              }
              (item.diagnosisFlag = item.diagnosisFlag == "1" ? "是" : "否"),
                (item.diagnosisSymptoms =
                  item.diagnosisSymptoms && item.diagnosisSymptoms.length > 0
                    ? item.diagnosisSymptoms.map((item) => item.label).join(",")
                    : ""),
                (item.familyHistoryData = item.familyHistory || []),
                (item.familyHistory =
                  item.familyHistory && item.familyHistory.length > 0
                    ? item.familyHistory.map((item) => item.label).join(",")
                    : ""),
                // [{label:'无',code:'wu'}]  若初始化显示无
                (item.presentIllnessData = item.presentIllness || []),
                (item.presentIllness =
                  item.presentIllness && item.presentIllness.length > 0
                    ? item.presentIllness.map((item) => item.label).join(",")
                    : "");
            });
            this.studentList = data;
            this.judgeDisabled();
          } else {
            this.$toast(res.message);
          }
          this.showLoading = false;
        })
        .finally(() => {
          this.showLoading = false;
        });
    },
  },
  created() {
    this.popDivContainer = document.createElement("div");
    document.body.appendChild(this.popDivContainer);
    this.showLoading = true;
    Promise.all([
      this.getRelationShip(),
      this.getDiagnosisSymptom(),
      this.getPresentIllness(),
      this.getFamilyMedicalHistory(),
      // 运动
      this.getMotorSymptoms(),
      // 语言
      this.getLanguageSymptoms(),
      //  作业
      this.getJobSymptoms(),
      // 心理
      this.getBehavioralSymptoms(),
      // 养育
      this.getParentingSymptoms(),
      // 智力低下
      this.getIntellectualSymptoms(),
    ])
      .then((values) => {
        let { isParent } = this.$route.query;
        // 代表从我的档案进来的
        if (isParent && isParent == "1") {
          this.getDetail();
        } else {
          this.showLoading = false;
        }
      })
      .catch((err) => {
        console.log(err);
        this.showLoading = false;
      });
  },
  mounted() {
    // this.getRelationShip();
    // this.getPresentIllness();
    // this.getFamilyMedicalHistory();
  },
};
</script>
<style lang="less" scoped>
div.child {
  position: relative;
  padding-bottom: 60px;
  /deep/.van-field__label {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #2e4344;
  }
  div.tip {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #2e4344;
    line-height: 17px;
    margin-bottom: 12px;
  }
  div.content-name {
    display: flex;
    margin-bottom: 12px;
    overflow-x: auto;
    padding-bottom: 10px;
    > div {
      flex-shrink: 0;
      width: 127px;
      height: 40px;
      background: #baf3f5;
      border-radius: 22px;
      margin-right: 12px;
      text-align: center;
      line-height: 40px;
      color: #161515;
      > span:first-child {
        margin-right: 4px;
      }
    }
    div.active {
      background: #12dce6;
      color: #ffffff;
    }
  }
  /deep/ .must > .van-field__label:before {
    content: "*";
    color: #ee3721;
    margin-right: 4px;
  }
  /deep/ .van-field__control {
    text-align: right;
  }
  /deep/ .normal {
    padding-bottom: 30px;
  }
  /deep/ .normal .van-field__control {
    text-align: left;
  }
  /deep/ .van-field__control::placeholder {
    color: #cccccc !important;
  }
  /deep/ .normal .van-field__label {
    color: #00aadf;
  }
  /deep/ textarea {
    box-sizing: border-box;
    padding: 8px 12px;
    background: #f3f6f7;
    border-radius: 4px;
    // width: 236px;
    height: 130px;
  }

  /deep/ .custom textarea {
    background: transparent;
    padding: 0;
  }
  /deep/ .van-field__word-limit {
    position: relative;
    top: -26px;
    left: -26px;
    .van-field__word-num {
      color: #00aadf;
    }
  }
  /deep/.van-button--block {
    width: 45%;
    display: inline-block;
  }
  /deep/.van-button--info {
    border: none;
    background: linear-gradient(180deg, #17e1eb 0%, #24bffb 100%);
  }
  /deep/.van-button--disabled {
    background: #949c9d;
    border: none;
  }
  /deep/ .van-icon__image {
    position: relative;
    top: 2px;
  }
  p.msg {
    background: #fff;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #00aadf;
    padding-left: 14px;
    padding-bottom: 16px;
  }
  div.extraBg {
    padding-top: 0;
    padding-bottom: 0;
    // margin-bottom:12px;
    /deep/.van-field__label {
      background: #f3f6f7;
      margin-right: 0;
      span {
        padding-left: 20px;
      }
    }
    /deep/.van-field__value {
      background: #f3f6f7;
    }
    /deep/.van-icon-arrow {
      margin-left: 0;
      background: #f3f6f7;
      // height: 100%;
      height: auto;
    }
    /deep/.van-field__label,
    /deep/.van-field__value,
    /deep/.van-icon-arrow {
      padding: 16px 0 0 0;
    }
  }
  div.active {
    /deep/.van-field__label,
    /deep/.van-field__value,
    /deep/.van-icon-arrow {
      background: #e5f6fb;
    }
    /deep/ textarea {
      color: #00aadf;
    }
  }
  div.empty {
    height: 12px;
    background: #fff;
  }
  div.empty40 {
    height: 10px;
  }
  div.remove {
    position: absolute;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
    // margin: 0 auto;
    // margin-top: 16px;
    width: 118px;
    height: 28px;
    line-height: 28px;
    background: rgba(14, 215, 225, 0.1);
    border-radius: 14px;
    text-align: center;
    img {
      width: 22px;
      vertical-align: middle;
    }
    span {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #0ed7e1;
    }
  }
  p.title {
    margin-top: 35px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #2e4344;
    text-align: center;
  }
  div.content {
    display: flex;
    flex-wrap: wrap;
    margin-top: 20px;
    margin-left: 10px;
    > div {
      margin-left: 10px;
      margin-bottom: 12px;
      background: rgba(250, 125, 0, 0.1);
      border-radius: 20px;
      padding: 10px 12px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #fa7d00;
    }
    div.active {
      background: #de8e43;
      color: #fff;
    }
  }
  div.btns {
    width: 335px;
    height: 44px;
    background: linear-gradient(180deg, #17e1eb 0%, #24bffb 100%);
    border-radius: 22px;
    margin: 45px auto;
    line-height: 44px;
    text-align: center;
    color: #ffffff;
  }
  .activeText {
    /deep/ .van-field__control {
      color: #00aadf;
    }
  }
  .clrTop {
    padding-top: 0;
  }
  .clrBot {
    padding-bottom: 0;
  }
  .loading {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(255, 255, 255, 0.8);
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .buttonBottom {
    // margin: 16px;
    display: flex;
    justify-content: space-between;
    position: fixed;
    bottom: 16px;
    .buttonBottom_left,
    .buttonBottom_right {
      width: 156px;
      height: 40px;
      background: linear-gradient(180deg, #17e1eb 0%, #24bffb 100%);
      border-radius: 22px;
      text-align: center;
      line-height: 40px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
    }
    .buttonBottom_left {
      margin-right: 23px;
    }
  }
}
</style>
